import { render } from "./ScheduleApp.vue?vue&type=template&id=37a160d1&scoped=true"
import script from "./ScheduleApp.vue?vue&type=script&lang=js"
export * from "./ScheduleApp.vue?vue&type=script&lang=js"

import "./ScheduleApp.vue?vue&type=style&index=0&id=37a160d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a160d1"]])

export default __exports__